/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import jsone from 'json-e';

import { schema } from './pg-config.schema';

export type Context = { cluster: Record<'cpu' | 'memory' | 'storage', number> };

export const render = (context: Context): typeof schema => {
  return jsone(schema, context);
};
